import { useContext, useState } from 'react';
import axios from '../../../sharedModules/utils/axios.utils';
import { SnackBarContext } from '../../../sharedModules/form/contexts/SnackBarContext';

interface UseInvoicePdfDeleteArgs {
  onDeleted?: (applyTo: string, pdfId: number) => void;
}

export function useInvoicePdfDelete({ onDeleted }: UseInvoicePdfDeleteArgs) {
  const { showErrorSnackBar, showSuccessSnackBar } = useContext(SnackBarContext);
  const [deletingPdfId, setDeletingPdfId] = useState<number | null>(null);

  const deletePdf = async (applyTo: string, pdfId: number, filename: string) => {
    const confirmed = window.confirm(
      `Delete "${filename}"? You can upload a replacement afterward.`,
    );
    if (!confirmed) return;

    setDeletingPdfId(pdfId);
    try {
      await axios.delete(`/collections/edoc_invoice_imports/${pdfId}`);
      onDeleted?.(applyTo, pdfId);
      showSuccessSnackBar?.('Invoice PDF deleted.');
    } catch (err: unknown) {
      const msg =
        (err as { response?: { data?: { error?: string } } })?.response?.data?.error ?? 'Failed to delete PDF';
      showErrorSnackBar?.(msg);
    } finally {
      setDeletingPdfId(null);
    }
  };

  return { deletePdf, deletingPdfId };
}
